import React, { useEffect } from 'react'
import { format } from 'date-fns'
import connect from './connect'
import SharingLinkModal from './sharing_link_modal'

const { I18n } = window

function SharingLinks({
  toggleDialog,
  saveSharingLink,
  deleteSharingLink,
  dialogOpened,
  isFetching,
  newSharingLink,
  currentLink,
  sharingLinks,
  loadSharingLinks,
  links,
  successMessage,
  errorMessage,
}) {
  useEffect(() => {
    loadSharingLinks(sharingLinks)
  }, [sharingLinks])
  return (
    <div className="sharing-links">
      <div className="sharing-links-list mb-2">
        {links.map((link) => {
          return (
            <div key={link.id}>
              <a href="javascript:void(0)" onClick={() => toggleDialog(true, link)}>
                {`${link.user.name} / ${format(link.expiresAt, 'yyyy-MM-dd')}`}
              </a>
            </div>
          )
        })}
      </div>
      <button className="btn btn-secondary w-100" type="button" onClick={() => toggleDialog(true, newSharingLink)}>
        {I18n.t('project_tickets.sharing_block.new_sharing_link_button_title')}
      </button>
      {currentLink && (
        <SharingLinkModal
          dialogOpened={dialogOpened}
          toggleDialog={toggleDialog}
          currentLink={currentLink}
          isFetching={isFetching}
          saveSharingLink={saveSharingLink}
          deleteSharingLink={deleteSharingLink}
          successMessage={successMessage}
          errorMessage={errorMessage}
        />
      )}
    </div>
  )
}

export default connect(SharingLinks)
